"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractGqlData = exports.stringToGQL = exports.GraphqlProvider = exports.useGraphqlClient = exports.useInitGraphqlClient = exports.initializeGraphqlClient = exports.gql = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@apollo/client");
const client_2 = require("@apollo/client");
const context_1 = require("@apollo/client/link/context");
const apollo_upload_client_1 = require("apollo-upload-client");
const cross_fetch_1 = tslib_1.__importDefault(require("cross-fetch"));
const react_1 = require("react");
var client_3 = require("@apollo/client");
Object.defineProperty(exports, "gql", { enumerable: true, get: function () { return client_3.gql; } });
let graphqlClient;
function getGraphqlClient() {
    return graphqlClient;
}
function createGraphqlClient(uri, cacheConfig) {
    const httpLink = apollo_upload_client_1.createUploadLink({
        uri,
        fetch: cross_fetch_1.default,
        credentials: "include",
    });
    const authLink = context_1.setContext((_, prevContext) => {
        const { headers } = prevContext;
        // Get the authentication token from local storage if it exists
        const token = localStorage.getItem("token");
        // Return the headers to the context so httpLink can read them
        return {
            headers: Object.assign(Object.assign({}, headers), { Authorization: token ? `Bearer ${token}` : "" }),
        };
    });
    return new client_1.ApolloClient({
        ssrMode: typeof window === "undefined",
        link: authLink.concat(httpLink),
        cache: new client_1.InMemoryCache(cacheConfig),
    });
}
function initializeGraphqlClient(uri, initialState, cacheConfig) {
    const _graphqlClient = getGraphqlClient() || createGraphqlClient(uri, cacheConfig);
    // If your page has Next.js data fetching methods that use Apollo Client, the initial state
    // gets hydrated here
    if (initialState) {
        // Get existing cache, loaded during client side data fetching
        const existingCache = _graphqlClient.extract();
        // Restore the cache using the data passed from getStaticProps/getServerSideProps
        // combined with the existing cached data
        _graphqlClient.cache.restore(Object.assign(Object.assign({}, existingCache), initialState));
    }
    // For SSG and SSR always create a new Apollo Client
    if (typeof window === "undefined")
        return _graphqlClient;
    return _graphqlClient;
}
exports.initializeGraphqlClient = initializeGraphqlClient;
function useInitGraphqlClient(uri, initialState, cacheConfig) {
    const store = react_1.useMemo(() => initializeGraphqlClient(uri, initialState, cacheConfig), [
        initialState,
    ]);
    return store;
}
exports.useInitGraphqlClient = useInitGraphqlClient;
function useGraphqlClient() {
    return client_2.useApolloClient();
}
exports.useGraphqlClient = useGraphqlClient;
function GraphqlProvider({ uri, initialState, cacheConfig, children, }) {
    const graphqlClient = useInitGraphqlClient(uri, initialState, cacheConfig);
    return jsx_runtime_1.jsx(client_2.ApolloProvider, Object.assign({ client: graphqlClient }, { children: children }), void 0);
}
exports.GraphqlProvider = GraphqlProvider;
function stringToGQL(query) {
    return client_2.gql `
    ${query}
  `;
}
exports.stringToGQL = stringToGQL;
function extractGqlData(result) {
    const data = result && "object" === typeof result ? result[Object.keys(result)[0]] : result;
    return data;
}
exports.extractGqlData = extractGqlData;
//# sourceMappingURL=Client.js.map